module.exports = __webpack_public_path__ + "img/57_19.51f05406.png";